/**
 * 隐私协议及用户协议弹窗
 */
import { useEffect, useMemo, useState } from "react";
import { Modal } from "antd";
import ViewPdf from "@/components/ViewPdf";
import "./index.less";
import http from "@/api";

export const useModal = () => {
  const [isShowContract, setIsShowContract] = useState<boolean>(false);
  const [fileType, setFileType] = useState<"privacy" | "user">();
  const [documentConfig, setDocumentConfig] = useState<{
    account_privacy: string;
    account_userContract: string;
  }>();
  const viewContract = (type: "privacy" | "user") => {
    setFileType(type);
    setIsShowContract(true);
  };
  const getAuthConfig = async () => {
    const res: any = await http.getAuthConfig();
    if (res?.code == 200) {
      setDocumentConfig(res?.data?.documentConfig);
    }
  };

  const fileUrl = useMemo(() => {
    if (fileType === "privacy") {
      return documentConfig?.account_privacy || "";
    }
    if (fileType === "user") {
      return documentConfig?.account_userContract || "";
    }
  }, [fileType]);

  useEffect(() => {
    getAuthConfig();
  }, []);

  return {
    isShowContract,
    fileType,
    fileUrl,
    viewContract,
    setFileType,
    setIsShowContract,
  };
};

export default function PrivacyModel(props: any) {
  //   const { visible, onCancel } = props;
  const { fileType = "privacy", fileUrl, open = false, ...restProps } = props;
  return (
    <Modal
      title={null}
      width={920}
      centered
      maskClosable={false}
      destroyOnClose
      wrapClassName="contract-modal"
      open={open}
      {...restProps}
    >
      <div className="contract-modal-main">
        <div className="contract-title">{fileType === "privacy" ? "隐私政策" : "用户协议"}</div>
        <div className="contract-container">
          <ViewPdf fileType={fileType} fileUrl={fileUrl}></ViewPdf>
        </div>
      </div>
    </Modal>
  );
}
